<template>
  <div>
    <ol class="breadcrumb" style="border-radius:0" >
      <li class="breadcrumb-item">
        <router-link v-bind:to="'/' + $i18n.locale + '/' + property.slug + '/' + $t('reports.url')">
          {{ $t('reports.name') }}
        </router-link>
      </li>
      <li class="breadcrumb-item" aria-current="page">{{ $t('deletionReport') }}</li>
    </ol>
    <div class="container-fluid">
      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">
            {{ $t('deletionReport') }}
            -
            {{year}}
          </h1>
          <p class="lead text-muted">
            {{ $t('deletionReport') }}
            {{ $t('forProperty') }}
            {{property.name}}
          </p>
        </div>
      </header>
      <div class="content">
        <div class="row">
          <div class="col-md-6 border-right">
            <h2>Zapisnik o izbrisu podatkov iz knjige gostov za leto {{year}}</h2>

            <p>
              Naziv objekta: {{report.property.name}}
              <br>
              ID objekta: {{report.property.eTurizem.idNO}}
            </p>

            <p>
              Dne {{ report.created | date }}  smo v skladu z Zakonom o prijavi prebivališča in
              3. členom Pravilnika o prijavi in odjavi gostov opravili izbris podatkov iz elektronske knjige gostov za:
            </p>

            <ul v-for="deleted in report.deletedGuests">
              <li>leto {{deleted.year}} od zaporedne št. {{deleted.min}} do zaporedne št. {{deleted.max}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment';


export default {
  name: 'GuestbookReport',
  data: () => ({
    title: '',
    property: '',
    report: {
      property: {
        eTurizem: {}
      },
      deletedGuests: []
    }
  }),
  filters: {
    date: function(date){
      if(!date) return '';
      return moment(date).isValid() ? moment(date).format('DD/MM/YYYY') : "";
    }
  },
  created(){
    const propSlug = this.$route.params.property;

    this.property = this.$store.state.host.properties.find(p => p.slug == this.$route.params.property);
    this.year = this.$route.params.year;

    fetch(process.env.VUE_APP_API + '/properties/' + this.property._id + '/deletion-report/' + this.year, {
      method: 'get',
      credentials: 'include',
      headers: {
        "Content-type": "application/json",
        "Accept": "application/json",
        "Accept-Charset": "utf-8",
        'CSRF-Token': this.$csrf
      }
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      console.log(response)
      this.report = response;
    })
  }
};
</script>

<i18n>
{
  "en": {
    "reports": {
      "name": "Reports",
      "url": "reports"
    },
    "deletionReport": "Guest deletion report",
    "forProperty": "for property",
    "title": "Title",
    "tax": "Tax",
    "amount": "Amount",
    "quantity": "Quantity"
  },
  "sl": {
    "reports": {
      "name": "Poročila",
      "url": "porocila"
    },
    "deletionReport": "Poročilo o izbrisu gostov",
    "forProperty": "nastanitve",
    "title": "Naziv",
    "tax": "Taksa",
    "amount": "Znesek",
    "quantity": "Količina"
  }
}
</i18n>
